import React from 'react';
import './Footer.css';

const Footer = ({ t }) => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-col">
            <img src={`${process.env.PUBLIC_URL}/images/logo2.png`} alt="Smiling Senegal" className="footer-logo" />
            <p>{t.description}</p>
          </div>
          <div className="footer-col">
            <h4>{t.quickLinks}</h4>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#tours">Tours</a></li>
              <li><a href="#gallery">Gallery</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>{t.services}</h4>
            <ul>
              {t.servicesList.map((service, index) => (
                <li key={index}><a href="#tours">{service}</a></li>
              ))}
            </ul>
          </div>
          <div className="footer-col">
            <h4>{t.contactUs}</h4>
            <ul>
              <li><i className="fas fa-map-marker-alt"></i> Dakar, Senegal</li>
              <li><i className="fas fa-phone"></i> +221 77 777 77 77</li>
              <li><i className="fas fa-envelope"></i> contact@smilingsn.com</li>
            </ul>
          </div>
        </div>
        <div className="footer-legal">
          <div className="legal-info">
            <div className="legal-item">
              <i className="fas fa-file-contract"></i>
              <div>
                <span className="legal-label">NINEA</span>
                <span className="legal-value">31253422X1</span>
              </div>
            </div>
            <div className="legal-item">
              <i className="fas fa-stamp"></i>
              <div>
                <span className="legal-label">Registre du Commerce</span>
                <span className="legal-value">SNTHS2007A1217</span>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2026 Smiling Senegal. {t.rights}</p>
        </div>
      </div>
      <a href="https://wa.me/221777777777" className="whatsapp-float" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-whatsapp"></i>
      </a>
    </footer>
  );
};

export default Footer;
